module.exports = __webpack_public_path__ + "img/icon_Global_Advertising.ed7f5df9.svg";